module.exports = __webpack_public_path__ + "static/img/407.6532ab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/407.jpg
// module id = uZTc
// module chunks = 0